import { computed, inject, type ComputedRef, type InjectionKey } from 'vue'
import { defaultClasses, type Classes } from '../../core/classes'

/** CSS classes of this instance, provided by SearchResults from its `classes` prop. */
export const CLASSES: InjectionKey<ComputedRef<Classes>> = Symbol('agent-search-classes')

/**
 * The CSS classes of the built-in components, merged with the instance's override.
 * Usage: `const classes = useClasses()`, then `:class="classes.teaser.title"`. Overrides of components can use it too.
 */
export function useClasses(): ComputedRef<Classes> {
    return inject(CLASSES, computed(() => defaultClasses))
}
